@if (!isMobileVersion) {
    <li class="close-drawbar-button">
        <button (click)="closeDrawBar()" title="Schließen">
            <i class="fas fa-times"></i>
        </button>
    </li>
    <li [class.active]="fabricService.currentDrawAction && fabricService.currentDrawAction.drawActionElement == drawActionElements.FREEHAND"
        class="draw-bar-list-element">
        <button (click)="selectDrawingAction($event, drawActionElements.FREEHAND)"
                data-bs-placement="left"
                data-bs-toggle="tooltip"
                title="Freihandwerkzeug">
            <img [src]="'draw-mode/icon-tool-drawing-freehand.png' | asset" alt="Freihand zeichnen">
        </button>
    </li>
    <li [class.active]="fabricService.currentDrawAction && fabricService.currentDrawAction.drawActionElement == drawActionElements.LINE"
        class="draw-bar-list-element">
        <button (click)="selectDrawingAction($event, drawActionElements.LINE)"
                data-bs-placement="left"
                data-bs-toggle="tooltip"
                title="Linie">
            <img [src]="'draw-mode/icon-tool-drawing-line.png' | asset" alt="Einen Linie zeichnen">
        </button>
    </li>
    <li [class.active]="fabricService.currentDrawAction && fabricService.currentDrawAction.drawActionElement == drawActionElements.CIRCLE"
        class="draw-bar-list-element">
        <button (click)="selectDrawingAction($event, drawActionElements.CIRCLE)"
                data-bs-placement="left"
                data-bs-toggle="tooltip"
                title="Kreis">
            <img [src]="'draw-mode/icon-tool-drawing-circle.png' | asset" alt="Einen Kreis zeichnen">
        </button>
    </li>
    <li [class.active]="fabricService.currentDrawAction && fabricService.currentDrawAction.drawActionElement == drawActionElements.RECT"
        class="draw-bar-list-element">
        <button (click)="selectDrawingAction($event, drawActionElements.RECT)"
                data-bs-placement="left"
                data-bs-toggle="tooltip"
                title="Rechteck">
            <img [src]="'draw-mode/icon-tool-drawing-rectangle.png' | asset" alt="Ein Rechteck zeichnen">
        </button>
    </li>
    <li [class.active]="fabricService.currentDrawAction && fabricService.currentDrawAction.drawActionElement == drawActionElements.TRIANGLE"
        class="draw-bar-list-element">
        <button (click)="selectDrawingAction($event, drawActionElements.TRIANGLE)"
                data-bs-placement="left"
                data-bs-toggle="tooltip"
                title="Dreieck">
            <img [src]="'draw-mode/icon-tool-drawing-triangle.png' | asset" alt="Ein Dreick zeichnen">
        </button>
    </li>
    <li [class.active]="thirdLayerSlug === 'stamp'"
        class="draw-bar-list-element">
        <button (click)="selectThirdLayer('stamp')"
                data-bs-placement="left"
                data-bs-toggle="tooltip"
                title="Stempelwerkzeug">
            <img [src]="'draw-mode/icon-tool-drawing-stamps.png' | asset" alt="Stempel-Vorlagen">
        </button>
        @if (thirdLayerSlug === 'stamp') {
            <div class="tooltip fade left in" id="stampTooltip" role="tooltip">
                <div class="tooltip-arrow" style="top: 50%;"></div>
                <div class="tooltip-inner no-padding">
                    <ul>
                        <li (click)="selectDrawingAction($event, drawActionElements.STAMP, 'icon-stempel-smilie-happy.svg')">
                            <img [src]="'draw-mode/icon-stempel-smilie-happy.png' | asset"
                                 alt="Smiley fröhlich-Stempel"/>
                        </li>
                        <li (click)="selectDrawingAction($event, drawActionElements.STAMP, 'icon-stempel-smilie-sad.svg')">
                            <img [src]="'draw-mode/icon-stempel-smilie-sad.png' | asset" alt="Smiley traurig-Stempel"/>
                        </li>
                        <li (click)="selectDrawingAction($event, drawActionElements.STAMP, 'icon-stempel-star.svg')">
                            <img [src]="'draw-mode/icon-stempel-star.png' | asset" alt="Stern-Stempel"/>
                        </li>
                        <li (click)="selectDrawingAction($event, drawActionElements.STAMP, 'icon-stempel-thumbsup.svg')">
                            <img [src]="'draw-mode/icon-stempel-thumbsup.png' | asset" alt="Daumen hoch-Stempel"/>
                        </li>
                        <li (click)="selectDrawingAction($event, drawActionElements.STAMP, 'icon-stempel-thumbsdown.svg')">
                            <img [src]="'draw-mode/icon-stempel-thumbsdown.png' | asset" alt="Daumen runter-Stempel"/>
                        </li>
                        <li (click)="selectDrawingAction($event, drawActionElements.STAMP, 'icon-stempel-lightbulb.svg')">
                            <img [src]="'draw-mode/icon-stempel-lightbulb.png' | asset" alt="Glühbirne-Stempel"/>
                        </li>
                        <li (click)="selectDrawingAction($event, drawActionElements.STAMP, 'icon-stempel-check.svg')">
                            <img [src]="'draw-mode/icon-stempel-check.png' | asset" alt="Korrekt-Stempel"/>
                        </li>
                        <li (click)="selectDrawingAction($event, drawActionElements.STAMP, 'icon-stempel-x.svg')">
                            <img [src]="'draw-mode/icon-stempel-x.png' | asset " alt="Falsch-Stempel"/>
                        </li>
                        <li (click)="selectDrawingAction($event, drawActionElements.STAMP, 'icon-stempel-lightningbolt.svg')">
                            <img [src]="'draw-mode/icon-stempel-lightningbolt.png' | asset" alt="Blitz-Stempel"/>
                        </li>
                    </ul>
                </div>
            </div>
        }
    </li>
    <li [class.active]="fabricService.currentDrawAction && fabricService.currentDrawAction.drawActionElement == drawActionElements.TEXT"
        class="draw-bar-list-element">
        <button (click)="selectDrawingAction($event, drawActionElements.TEXT)"
                data-bs-placement="left"
                data-bs-toggle="tooltip"
                title="Textwerkzeug">
            <img [src]="'draw-mode/icon-tool-drawing-text.png' | asset" alt="Text erstellen">
        </button>
    </li>
    <hr/>
    <ul class="options-menu">
        <li [class.active]="thirdLayerSlug === 'color'"
            class="draw-bar-list-element">
            <button (click)="selectThirdLayer('color')"
                    data-bs-placement="left"
                    data-bs-toggle="tooltip"
                    title="Farbauswahl">
        <span class="circle-container">
                    <span [ngStyle]="{
                    'background-color': fabricService.currentColor.color.getColorString()
                }" id="colorCircle">
          </span>
        </span>
                <span>Farbe</span>
            </button>
            @if (thirdLayerSlug === 'color') {
                <div class="tooltip fade left in" id="colorTooltip" role="tooltip">
                    <div class="tooltip-arrow custom-tooltip-arrow" style="top: 50%;"></div>
                    <div class="tooltip-inner">
                        <app-draw-mode-color-picker
                                [colorable]="fabricService.currentColor"></app-draw-mode-color-picker>
                    </div>
                </div>
            }
        </li>
        <li [class.active]="thirdLayerSlug === 'borderWidth'"
            class="draw-bar-list-element">
            <button (click)="selectThirdLayer('borderWidth')"
                    class="d-flex flex-column align-items-center"
                    data-bs-html="true"
                    data-bs-placement="left"
                    data-bs-toggle="tooltip"
                    title="<em>Rahmenlinie</em><br/>Stärke ändern">
                <img [src]="'draw-mode/icon-tool-drawing-border-width.png' | asset" alt="Linienstärke wählen">
                <span>Stärke</span>
            </button>
            @if (thirdLayerSlug === 'borderWidth') {
                <div class="tooltip fade left in" id="borderWidthTooltip" role="tooltip"
                >
                    <div class="tooltip-arrow custom-tooltip-arrow" style="top: 50%;"></div>
                    <div class="tooltip-inner no-padding">
                        <ul>
                            @for (borderWidth of borderWidths; track borderWidth) {
                                <li
                                        (click)="selectBorderWidth(borderWidth)"
                                        [class.active]="fabricService.currentBorderWidth === borderWidth">
                                    <div [ngStyle]="{'height.px': (borderWidth + 2), 'background-color': fabricService.currentColor.color.getColorString()}"
                                         class="line">
                                    </div>
                                </li>
                            }
                        </ul>
                    </div>
                </div>
            }
        </li>
    </ul>
}